<template>
   <the-content v-model="showFilters">

    <template v-slot:content>
       <efficiency />
    </template>

    <template v-slot:sidebar>
      <filters :root-module='rootModule' :dateRangePlaceholder='dateRangePlaceholder' />
    </template>

    <template v-slot:mobile-sidebar>
      <filters :root-module='rootModule' :dateRangePlaceholder='dateRangePlaceholder' @close="showFilters = false"/>
    </template>

  </the-content>
</template>

<script>
import Efficiency from '@/components/dashboard/Efficiency.vue'
import TheContent from '@/components/Content.vue'
import Filters from '@/components/dashboard/Filters.vue'

export default {
  components: {
    Efficiency,
    TheContent,
    Filters
  },
  data () {
    return {
      rootModule: 'dashboard',
      dateRangePlaceholder: 'Отчет за период',
      showFilters: false
    }
  }
}
</script>
